import { Redirect, Route, RouteProps } from 'react-router-dom';

import React from 'react';
import { useSession } from 'src/hooks/useSession';

export default function ProtectedRoute({ ...routeProps }: RouteProps): JSX.Element {
  const { isLogged } = useSession();
  return isLogged ? <Route {...routeProps} /> : <Redirect to={{ pathname: '/login' }} />;
}
